module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('big', [_c('big', [_c('b', [_vm._v("O")])])], 1), _vm._v("n May 4, 1873, two Hartford men went fishing on the Farmington River in Granby and returned with 341 trout. Around this time, the "), _c('i', [_vm._v("Hartford Courant")]), _vm._v(" ran an article lamenting the fact that American shad in the Connecticut River were “rapidly diminishing in number…and size.” Indeed, Barton Douglas, a longtime fisherman, operator of the Windsor canal, and owner of a ferry business, told the fisheries commission at the state legislature “shad fishing was nearly used up.” Atlantic salmon in the rivers and streams of the state were virtually gone. The fisheries commission reported to the legislature that “the restoration of the salmon is the hardest task before the commission. At present they are nearly exterminated.” In sum, by the late-1870s, Connecticut was almost fished out. Not surprisingly, the biggest culprits were over-fishing and market hunting. Other factors include the denuding of the forests—the natural canopy ensured cool water temperatures in the streams—and to a lesser extent, the construction of dams during America's great waterpower manufacturing boom of the nineteenth century.")], 1), _vm._v(" "), _vm._m(1)]), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6), _vm._m(7), _vm._m(8), _vm._m(9), _vm._m(10), _vm._m(11), _vm._m(12), _vm._m(13), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._m(14), _vm._m(15), _vm._m(16), _vm._m(17), _vm._m(18), _vm._m(19), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ch-img"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/ch1.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_vm._v("American shad, or Alosa sapidissima, meaning “most delicious,” swim upstream from marine waters to spawn in the springtime.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Leading up to the complete decimation of the fish population in the state, the legislature had not been ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("completely idle. In its 1860 spring session, the General Assembly announced a fisheries commission. A year later, Connecticut's first fish and game laws were passed. As regards trout, the statute read, “That any person…between the first day of September and the first day of January, in any year…catch…any speckled brook trout, or speckled river trout, or lake trout, shall forfeit for each trout the sum of one dollar….” However, there was no mention of fish size or creel limit.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_vm._v("A creel is a basket used to carry fish. “Creel limit” means the number of fish you can take home in your basket.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the absence of any fish and game wardens—and recognizing the fast-diminishing fish populations in the state's rivers and streams—a Poquonock father and son team of farmers, Fred and Henry Fenton, petitioned the legislature for a charter for a fish-hatching business in 1872. On Champion Brook, a small tributary of the Farmington River, the two Fentons raised Atlantic salmon and trout. The fish were fed ground sheep's liver, three times a day. This diet dulled the trout's vivid colors, and many of the trout lost their bright spots entirely. Fortunately, the condition remedied itself shortly after the fish were released into the wild.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_vm._v("There are two types of Atlantic salmon, those that spend part of their lives in salt water and those that complete their life cycles in fresh water; but the two types were not recognized until about 1896.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1881, the Fenton Trout Breeding Company raised 600,000 Atlantic salmon and 275,000 brook trout, which were sold to the state. Soon thereafter, the Fentons managed three hatchery buildings with a breeding capacity of two million eggs behind their farmhouse. In 1882, rainbow trout were imported from California for streams that couldn't support brook trout because of higher water temperatures. (German brown trout eggs were shipped from Baron Lucius von Behr's private estate in the Black Forest to a newly completed hatchery at Cold Spring Harbor on Long Island in 1883, but brown trout did not show up in Connecticut waters until a decade later.)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("The state was a bit gun-shy about starting a permanent fish-breeding business of its own though, as the fish ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("commissioners noted, “it would cost too much to establish a state hatchery.” But from the start, Connecticut's inland trout and Atlantic salmon efforts were a bargain. In 1882, a "), _c('i', [_vm._v("Courant")]), _vm._v(" reader complained of the cost of running the state's fisheries. At that time, the cost of the hatchery purchases and the state's stocking program ran $690, while revenues from statewide taxation were $1.7 million. In answer to the subscriber's letter, an editor at the "), _c('i', [_vm._v("Courant")]), _vm._v(" performed some rudimentary math and concluded that the town of Windsor—where the subscriber lived—paid less than $1 a year toward the state's hatchery and stocking program.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_vm._v("Trout fry are baby trout. Fry, borrowed from the French word frai, literally means spawn.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By this time, Henry Fenton was the state's de facto fish-culture expert. Accordingly, the fish commissioners named him superintendent of the state's hatchery operations.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Beginning in 1880, as part of a new fish-stocking initiative, the state accepted applications for free trout fry from state farmers and sportsmen. One hundred and fifty applicants were each given 5,000 trout fry—in an eight-gallon can—at no charge. The state's only rule was that ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("the fish could not be put into private waters; they had to be released into public rivers and streams. Five years later, thirty-five-year-old Henry Fenton was elected to the state legislature and became the conduit for all applications for free trout fry.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/6_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('i', [_vm._v("Kettle Brook Hatchery, Windsor Locks")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, in the late 1880s, the fish commissioners— perhaps in a reassessment of Henry Fenton's fish-hatching monopoly—decided that the state should have its own trout breeding facilities and set up a temporary hatchery in the old Hathaway Mill on River Street in Poquonock. Fenton was placed in charge of this facility. Meanwhile, the fish commissioners badgered the General Assembly for the land and buildings to build a permanent structure.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_vm._v("Anglers often refer to brook trout, Salvelinus fontinalis, as brookies, hinting at a bit of playfulness—maybe because they are fun to catch, and plentiful.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1889, the legislature appointed Abbott C. Collins, an actuary with Connecticut Mutual Life Insurance Company and a fish commissioner, to the post of Game and Fish Warden of Hartford County for a period of two years. At the same session, the legislature set the catchable size of brook trout at six inches. They also noted, “It is unlawful to catch brook trout from July 1 to April 1, and then only by hook and line.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fish Commissioner Abbott Collins started the state's first permanent hatchery in 1897 on an eminently suitable 16-acre piece of land on Spring Street in Windsor Locks— a little over a mile west of the town's train depot. On a mile-long stretch of Kettle Brook, the state erected a crude, temporary hatching house with 15 tanks. That fall, hatchery employees released 35,000 brook and rainbow trout from 6-to 8.5-inches long, 20,000 lake trout from 5- to 6- inches long, and 60,000 Atlantic salmon from 2- to 3.5-inches long. A permanent hatchery building was finally completed in the fall of 1899. By December, the new facility set 1.5 million eggs a year, which produced 250,000 trout. (At this time, the state also had two shad hatcheries at Joshuatown in Lyme and at Peck's Pond on the Housatonic River below Shelton.)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Thirty-gallon cans of trout and Atlantic salmon fry were ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("shipped from the new hatchery in the fall of 1899 and the diversity of fish was remarkable—75,000 brookies, 40,000 lake trout, 6,000 rainbow trout, 15,000 steel head, 2,000 Loch Leven trout, 50,000 Atlantic salmon, and 15,000 of the land-locked variety.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/8_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('i', [_vm._v("Rearing Ponds, Kettle Brook Hatchery, Windsor Locks")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Windsor Locks hatchery on Kettle Brook was an enormous success thanks to its fabulous water supply. A number of underground springs supplied 300,000 gallons of water a day to the hatchery before it finally spilled out into Kettle Brook. The water was crystal clear and its temperature was a constant 53 degrees Fahrenheit yearround. Each November, the hatchery's 5,000 breeding trout delivered two million eggs, half of which would hatch out the following spring.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_vm._v("Suckers have no teeth and big lips, so they feed by vacuuming their food from riverbeds. They prefer clean, unpolluted waters and often swim with trout.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("An important distinction between the fishing of the late nineteenth century and the early twentieth century, and that of a much later period, lay in the economic importance of trout, Atlantic salmon, and shad to the family table. The fish commissioners were proud of the fact that these fish were often sold in local markets cheaper than “suckers” (freshwater fish of the Catostomidae family). Moreover, they wrote, “it cannot be many years before good edible fish will be produced (in Connecticut waters) in such abundance as to be within the means of the poorest.” Beyond that, the fish commissioners were ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("keenly aware of the symbiosis of good fishing and tourism, stating, “the state needs but plenty of fish and game to make it still more attractive to summer and fall visitors from other states.”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1905, the legislature approved funds for a lobster hatchery at Noank. In the first two decades of the twentieth century, the state's hatcheries furnished brook, rainbow, and lake trout along with small-mouthed bass, yellow perch, American shad, and 125 million lobsters. A total of 130,585,830 and fry were added to the natural compliment of fish and crustaceans.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_vm._v("“Fingerling” means very young fish. The term most often refers to a baby trout or salmon that has reached the length of a man's finger.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Henry Fenton and a local worker, Gilbert Sterling, originally ran the Windsor Locks plant, but were replaced by William Tripp, who had been manager of the hatcheries at South Wareham, Massachusetts. Tripp was head of the Fisheries Division from 1898 to 1923. At that time, John Wheelock Titcomb—a man with thirty-four years experience in fish breeding in countries as far away as Argentina—became superintendent and William Tripp stayed on as the foreman of the facility at Windsor Locks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Kettle Brook Hatchery in Windsor Locks was a great success, but eventually deteriorated for the exact reason that it was such a world-beater from the start— the water supply. By 1923, the copious spring water had dwindled to a fraction of the 215 gallons a minute it furnished in 1897. Beyond this insuperable problem, fertilizer runoff from nearby tobacco fields despoiled the dwindling supply. Pollution regulation and source-to-sea cleanups were decades away. It was time for a new hatchery.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/10_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('i', [_vm._v("Loading a trout-stocking truck")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Attempts to build hatcheries in Salisbury and Waterbury proved fruitless, and in the fall of 1923, the state bought land for a second facility in Burlington. The main hatchery was fabricated from the former dance pavilion at Electric Park in Rockville.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John Wheelock Titcomb's tenure was notable for the construction of the new state hatchery at Burlington and the leasing of trout streams throughout the state. While it was quite fashionable for farmers and sportsman to maintain their own trout streams and ponds, this behavior was circumvented in great measure by the leasing of streams for public use. “Gentleman George” McLean, governor of Connecticut from 1901 to 1903, had his own private fishing pond on his estate in Simsbury. Ineligible for statebred trout, he paid $4 per thousand trout brought in from a hatchery on Cape Cod.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the financial side, in the first ten months of 1924, there were 44,671 angling licenses sold in Connecticut. Residents—totaling 33,583—paid $1; non-residents—715 with land in the state—paid the same; another 4,312 non-residents paid $2. The $49,013 in licensing revenues completely paid for the state's hatcheries program.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Titcomb's successor, Dr. Russell Hunter of Wethersfield —whose tenure stretched from 1938 to 1953—summed up the role of head of the Fisheries Division succinctly in 1951 when he stated that his primary job was “enforcement.” He also went on to say, “One of the biggest problems…is to rearrange nature to please fishermen…lakes and ponds are so equipped as to support practically a fixed weight of meat (fish) at all times. The ponds provide algae and plants for the plant-eating fish and enough plant-eating fish to sustain the fish-eating fish. Year after year, this underwater battle for survival goes on and the weight of fish in the pond stays about the same. The problem…is to rearrange all of this so that the fixed amount of fish will be in the right species, weights and limits to please the fishermen.” During Dr. Hunter's time, only half of the trout needed were supplied by the hatcheries at Windsor Locks, Burlington, and Kensington. The rest were purchased from commercial breeders. By the early 1950s, enforcement officers spot-checking anglers' catches throughout the state had risen to thirty-five.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In order to meet the growing need for trout, small rearing stations were built in Farmington and Voluntown. Still, by 1970, the existing hatcheries could only meet half of the state's trout stocking needs. Another 30 percent came from commercial growers, and the U.S. Fish and Wildlife Service supplied the last 20 percent. Since the state was raising trout for half the cost of those bought from commercial growers, it seemed like a particularly opportune time to erect another hatchery.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/sam.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_c('i', [_vm._v("I love to visit the hatcheries. Both hatcheries give free tours to the public seven days a week. Be sure to call ahead—Burlington Hatchery 860-673-2340 or Quinebaug Valley Hatchery:860-564-7542. The Quinebaug Valley facility has exhibits that are fun to tour. In central Connecticut, a trip to the aquarium at Cabela's in East Hartford is well worthwhile. Their trout are from Rowledge Pond Aquaculture of Sandy Hook, a private hatchery")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("The Burlington Hatchery worked the western part of the state, and the Windsor Locks facility—older and smaller—stocked the northern reaches; so an enormous new trout-breeding plant in eastern Connecticut made sense. On 1,200 acres between the Quinebaug and Moosup rivers, the massive Quinebaug Valley Hatchery in Plainfield was completed in 1971. At the time—and even as late as the mid-1980s—it was the biggest fish hatchery east of the Mississippi River. That same year, the Kettle Brook Hatchery closed and the Town of Windsor Locks bought the land. Not long after, the Kensington Hatchery began raising Atlantic salmon as Connecticut's part of an interstate/federal program to re-introduce Atlantic salmon back to the waters of the Northeast. Connecticut essentially ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("has only two trout hatcheries now—Burlington (15 miles west of Hartford) and Quinebaug Valley (38 miles east of Hartford) in Plainville.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/12_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('i', [_vm._v("A boy bringing a trout to net")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If Connecticut is the gold standard in hatcheries and trout stocking, how do neighboring states fare? For many years, a New York visitor's fishing license permitted angling in many trout streams in the Adirondacks on a whirlwind expedition to the Empire State's northernmost reaches— the fabled Battenkill (on the New York side), the lovely and exciting West Branch of the Ausable, the North Branch of the Saranac, the Salmon (near Malone, where mobster Dutch Shultz once stood trial for bootlegging) and finally the Chateauguay River, in the apple country near the Canadian border. This fishing tour of the Adirondacks is not what it used to be. Sad to say, trout fishing is on the wane.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The same is true of other once-famous trout fishing areas of the Northeast. Anglers and state biologists suspect that acid rain, pesticide runoff, silt from stream bank erosion, and even geese have taken a toll on the streams and rivers. At present, states that are twice the size of Connecticut are stocking about half as many trout. The fisheries divisions of the New England states and New York are all trying to rebuild habitat and reinvigorate their trout fishing programs, but acid rain, deforestation, and budget cutbacks are impeding these efforts.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead1"
  }, [_c('b', [_vm._v("Stocking in Connecticut")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Raising 800,000 trout a year would be of little value without tank trucks and the manpower to equitably release fish over the lakes, rivers, and streams of Connecticut. The Inland Fisheries Division has used basically the same model aerated tanker trucks to relocate trout since the late 1930s. It's a long process. Weather permitting, the first round begins in early March and lasts until the end of May. In 2009, for example, 55 to 60 percent of the full year's supply of trout was stocked by opening day—the third Saturday in April (6 a.m.). The remaining 231,000 trout are distributed in different ways ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("on a variety of streams during the remainder of the season. In some places, there is only a single follow-up stocking, while in others, where the heaviest fishing pressures the fish population, trout are stocked until Labor Day.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("All of the trout-stocking numbers can be found in the State of Connecticut Department of Environmental Protection's "), _c('i', [_vm._v("Connecticut Fish Distribution Report")]), _vm._v(", but let's dissect a few number from the state's 2009 account just for the fun of it. Firstly, the number of trout stocked annually on the east and west sides of the Connecticut River are almost identical (West side–346,461; East side–356,287). Secondly, by watershed, trout are stocked as follows: Connecticut River watershed–211,245 (30% of the total); Thames watershed–195,056 (27.7% of the total); and Housatonic watershed–172,245 (24.5% of the total). Thirdly, the five towns (or town combinations) in Connecticut that received the most fish in 2009 were: Cornwall–18,000; Salisbury–14,316; Danbury-Milford–13,550; Eastford-Chaplin–12,824; and Thompson-Norwich–12,098. Lastly, if you add up all the trout stocked in the Housatonic River and the West Branch–Farmington River, it comes to about 22 percent of all the fish stocked in 2009 on the west side of the state.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/sam.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_c('i', [_vm._v("The senior biologists at the Inland Fisheries Division say that in the areas where the creel limit is two fish, 90 percent of the stocked fish are gone in seven to ten days; in the places where the creel limit is five, 90 percent are gone in four days! Connecticut's trout fisher folks are short on patience. They follow the stocking trucks and leave when the fish aren't biting.")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_vm._v("“Riparian” is derived from the Latin, riparius “of a natural riverbank,” so a “riparian agreement” refers to a deal made regarding the fishing rights on the shores of a given waterway.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Muddying the waters a bit, in eastern Connecticut, the levels of the Quinebaug, Salmon, and Natchaug Rivers get low in late ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("summer. The rivers whose water levels must be maintained by old riparian agreements—like the Farmington River (courtesy of the Metropolitan District Commission)—will by definition offer more consistent trout fishing throughout the season than rivers whose water levels are allowed to rise and fall with the seasons.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The streams of Connecticut's East and West sides vary in another way. In northwestern Connecticut, the trout waters flow easterly toward the Connecticut River. Thanks in large part to the Bolton Range—as high as 800 feet— the rivers and streams in the eastern part of the state flow toward Long Island Sound.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("The best trout fishing in eastern Connecticut is spread out along miles of meandering streams that sometimes run almost the length of the state. The best-stocked bodies of water in eastern Connecticut are the Quinebaug River, Blackwell's Brook (and Kitts Brook) in Canterbury, and Five Mile River, running through Thompson, Putnam, and Killingly. The Little River, in Hampton and Canterbury, also benefits from considerable stocking. Owing to eastern Connecticut's wide-ranging diversity of rivers and streams, many of the finest fishing holes in that part of the state remain a secret to the very people who live there. (See ")]), _c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" for some of Sam Tippet's favorite pools in eastern Connecticut.)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/sam.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_c('i', [_vm._v("Here's a little known fact. The Inland Fisheries Division stocks the following urban ponds with about 10,000 trout annually — Beardsley Park Pond in Bridgeport, Keney Park Pond in Hartford, Lake Wintergreen in Hamden, Upper Fulton Park Pond in Waterbury, and Mohegan Park Pond in Norwich.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d79414a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap1.vue
// module id = 75
// module chunks = 0